<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { getBirthFromAge } from '$lib/utils/helpers';
  
  const dispatch = createEventDispatcher<{ play: { year: number; month: number } }>();
  
  let inputMode: 'age' | 'birth' = 'age';
  
  // Age input mode
  let years = '';
  let months = '';
  
  // Birth date input mode
  let birthMonth = new Date().getMonth() + 1;
  let birthYear = '';
  
  let showError = false;
  
  function switchToAge() {
    inputMode = 'age';
    showError = false;
  }
  
  function switchToBirth() {
    inputMode = 'birth';
    showError = false;
  }
  
  function handlePlay() {
    showError = false;
    
    if (inputMode === 'age') {
      const y = parseInt(years) || 0;
      const m = parseInt(months) || 0;
      
      if (y < 0 || y > 120 || m < 0 || m > 11 || (y === 0 && m === 0)) {
        showError = true;
        return;
      }
      
      const totalMonths = y * 12 + m;
      const birth = getBirthFromAge(totalMonths);
      dispatch('play', birth);
    } else {
      const bm = birthMonth;
      const by = parseInt(birthYear);
      
      const currentYear = new Date().getFullYear();
      if (bm < 1 || bm > 12 || by < 1900 || by > currentYear) {
        showError = true;
        return;
      }
      
      dispatch('play', { year: by, month: bm });
    }
  }
</script>

<div id="area-checkprogress">
  <h2>Enter Your Age and Play</h2>
  <form class="selector-container" on:submit|preventDefault={handlePlay}>
    {#if inputMode === 'age'}
      <div id="ageselection">
        <div class="label">How old are you?</div>
        <div class="inputs">
          <input 
            type="number" 
            pattern="\d*" 
            inputmode="numeric" 
            bind:value={years}
            placeholder="years" 
            min="0" 
            max="120" 
          />
          <input 
            type="number" 
            pattern="\d*" 
            inputmode="numeric" 
            bind:value={months}
            placeholder="months" 
            min="0" 
            max="11" 
          />
        </div>
        <div class="switch-link">
          <a href="#/" on:click|preventDefault={switchToBirth}>Or enter time of birth</a>
        </div>
      </div>
    {:else}
      <div id="dateofbirthselection">
        <div class="label">Month and year of birth</div>
        <div class="inputs">
          <select bind:value={birthMonth}>
            <option value={1}>Jan</option>
            <option value={2}>Feb</option>
            <option value={3}>Mar</option>
            <option value={4}>Apr</option>
            <option value={5}>May</option>
            <option value={6}>Jun</option>
            <option value={7}>Jul</option>
            <option value={8}>Aug</option>
            <option value={9}>Sep</option>
            <option value={10}>Oct</option>
            <option value={11}>Nov</option>
            <option value={12}>Dec</option>
          </select>
          <input 
            type="number" 
            pattern="\d*" 
            inputmode="numeric" 
            bind:value={birthYear}
            placeholder="year" 
            min="1900" 
            max="2050" 
          />
        </div>
        <div class="switch-link">
          <a href="#/" on:click|preventDefault={switchToAge}>Or enter current age</a>
        </div>
      </div>
    {/if}

    <div id="checkprogress-area">
      <button type="submit" class="button big">Play!</button>
    </div>
  </form>
  
  {#if showError}
    <div id="age-error" class="error">
      <i class="bi-x-circle-fill"></i> Please check the input values
    </div>
  {/if}
</div>

<style>
  #area-checkprogress {
    text-align: center;
  }

  form.selector-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5em;
  }

  .label {
    text-align: left;
  }

  .inputs {
    display: flex;
    justify-content: center;
    gap: 0.5em;
  }

  .inputs input,
  .inputs select {
    width: 6em;
  }

  .switch-link {
    text-align: left;
  }

  .switch-link a {
    color: #888888;
    cursor: pointer;
  }

  #checkprogress-area {
    margin-left: 0.5em;
  }

  .error {
    color: #ef6480;
    margin: 1em 0 0 0;
  }

  h2 {
    margin-bottom: 1em;
  }
</style>
